export const RESOURCE = 'adminredemption';
export const ACTIONS = { GetByReferenceId: '/referenceId', GetByMembershipNumber: '/membershipnumber', GetMembershipRedemption: '/membershipredemption', Create: '' }